var _style, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmplifyLoyaltyLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 680 204.3",
    style: {
      enableBackground: "new 0 0 680 204.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.amplify-loyalty-logo .st0{fill:#FFFFFF;}\n\t.amplify-loyalty-logo .st1{fill:url(#SVGID_1_);}\n\t.amplify-loyalty-logo .st2{fill:url(#SVGID_00000127736936212401647460000012457662137444929947_);}\n\t.amplify-loyalty-logo .st3{fill:url(#SVGID_00000036972369701345023390000016864383946024019607_);}\n\t.amplify-loyalty-logo .st4{fill:#FFFFFF;}\n\t.amplify-loyalty-logo .st5{fill:url(#SVGID_00000106122914188834666080000003182985060734592183_);}\n\t.amplify-loyalty-logo .st6{fill:url(#SVGID_00000000918052657640316010000016872987456311921291_);}\n")), /*#__PURE__*/React.createElement("g", {
    className: "amplify-loyalty-logo"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.6,105.6h-24.2l-5.9,14.3h-14.2l32.9-75.8h0.8l32.9,75.8h-16.6L253.6,105.6z M248.8,93.5l-7-17.7 l-7.3,17.7H248.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M361.6,44v75.9h-14.4V85.1l-23.8,33.8h-0.2l-22.9-31.6v32.6h-13.9V44h0.1l37,52.4L361.4,44H361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M423.2,53.6c4.9,4.4,7.3,10.4,7.3,18c0,4.4-0.8,8.4-2.5,12.2c-1.7,3.8-4.4,6.9-8.2,9.4 c-3.8,2.4-8.7,3.7-14.7,3.7h-10.3v23.1h-14.4V47h22.1C411.4,47,418.3,49.2,423.2,53.6z M411.5,81c1.6-1.2,2.8-2.7,3.6-4.3 c0.7-1.7,1.1-3.2,1.1-4.8c0-2.6-0.8-5.1-2.3-7.5c-1.5-2.4-4.5-3.6-8.8-3.6h-10.3v22H405C407.7,82.8,409.8,82.2,411.5,81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M457.8,47v59H492v13.9h-48.6V47H457.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M521.3,47v72.9h-14.4V47H521.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M585.7,47v13.9h-31.2v16.5h27v13.9h-27v28.6h-14.4V47H585.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M660.2,47l-27.3,50.2v22.7h-14.4V97.2L591.6,47h17.7l16.7,33.7L642.4,47H660.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.3,134.7v20.5h11.9v4.8h-16.9v-25.3H214.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276.9,140.9c1.2-2,2.7-3.6,4.7-4.8c2-1.2,4.1-1.8,6.5-1.8c2.3,0,4.5,0.6,6.5,1.8c2,1.2,3.6,2.8,4.8,4.8 c1.2,2,1.8,4.1,1.8,6.4c0,2.3-0.6,4.5-1.8,6.5c-1.2,2-2.8,3.5-4.8,4.7c-2,1.2-4.1,1.7-6.5,1.7c-2.3,0-4.5-0.6-6.5-1.7 c-2-1.2-3.5-2.7-4.7-4.7c-1.2-2-1.7-4.1-1.7-6.5C275.1,145.1,275.7,142.9,276.9,140.9z M281.3,151.4c0.7,1.2,1.7,2.2,2.9,2.9 c1.2,0.7,2.5,1.1,4,1.1c1.4,0,2.7-0.4,3.9-1.1c1.2-0.7,2.1-1.7,2.8-2.9c0.7-1.2,1-2.6,1-4.1c0-1.5-0.3-2.9-1-4.1 c-0.7-1.2-1.6-2.2-2.8-2.9c-1.2-0.7-2.5-1.1-3.9-1.1c-1.4,0-2.8,0.4-3.9,1.1c-1.2,0.7-2.1,1.7-2.8,2.9c-0.7,1.2-1,2.6-1,4.1 C280.3,148.8,280.6,150.2,281.3,151.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M370.5,134.7l-9.5,17.5v7.9h-5v-7.9l-9.3-17.5h6.2l5.8,11.7l5.7-11.7H370.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M429,155h-8.4l-2.1,5h-4.9l11.4-26.3h0.3l11.4,26.3H431L429,155z M427.4,150.8l-2.4-6.2l-2.5,6.2H427.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M491.4,134.7v20.5h11.9v4.8h-16.9v-25.3H491.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M567.3,134.7v4.8h-6.2V160h-5v-20.5h-5.9v-4.8H567.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M639.1,134.7l-9.5,17.5v7.9h-5v-7.9l-9.3-17.5h6.2l5.8,11.7l5.7-11.7H639.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.4621,
    y1: 47.7762,
    x2: 159.4076,
    y2: 133.1205
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFA700"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4173A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.5,84.5l-54-54c-9.7-9.7-25.6-9.7-35.3,0L45.8,65.9h64.5c11.4,0,20.7,9.3,20.7,20.7s-9.3,20.7-20.7,20.7 h-23c-5.8,0-10.6,4.7-10.6,10.6v0.5c0,5.8,4.7,10.6,10.6,10.6h74.1l9-9C180.2,110,180.2,94.2,170.5,84.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047036329714907574280000013013940523709837497_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.9215,
    y1: 72.9292,
    x2: 134.8405,
    y2: 158.2497
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFA700"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4173A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047036329714907574280000013013940523709837497_)"
    },
    d: "M66.7,118.2v-0.5 c0-11.4,9.3-20.7,20.7-20.7h23c5.8,0,10.6-4.7,10.6-10.6c0-5.8-4.7-10.6-10.6-10.6H35.7l-8.5,8.5c-9.7,9.7-9.7,25.6,0,35.3l54,54 c9.7,9.7,25.6,9.7,35.3,0l34.9-34.9h-64C76,138.9,66.7,129.6,66.7,118.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmplifyLoyaltyLogo);
export default __webpack_public_path__ + "static/media/amplify-loyalty-logo.9066629bd35f160abbb568c4a4b319c4.svg";
export { ForwardRef as ReactComponent };